/* MoRetro 3D Reviews — compact premium Firebase */
(function(){
  const firebaseConfig = {
    apiKey: "AIzaSyBQkSD5zjXzEusBiNojCkfcKWiV6pe0OCI",
    authDomain: "moretro3d-avis.firebaseapp.com",
    projectId: "moretro3d-avis",
    storageBucket: "moretro3d-avis.firebasestorage.app",
    messagingSenderId: "1003541837024",
    appId: "1:1003541837024:web:17646f0ecd046524820c85",
    measurementId: "G-SFY6CDHX72"
  };

  const firebaseScripts = [
    "https://www.gstatic.com/firebasejs/10.12.5/firebase-app-compat.js",
    "https://www.gstatic.com/firebasejs/10.12.5/firebase-firestore-compat.js"
  ];

  function loadScript(src){
    return new Promise((resolve, reject) => {
      if ([...document.scripts].some(s => s.src === src)) return resolve();
      const script = document.createElement("script");
      script.src = src;
      script.async = true;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function escapeHtml(value){
    return String(value || "")
      .replaceAll("&","&amp;")
      .replaceAll("<","&lt;")
      .replaceAll(">","&gt;")
      .replaceAll('"',"&quot;")
      .replaceAll("'","&#039;");
  }

  function formatDate(ts){
    try{
      const date = ts && ts.toDate ? ts.toDate() : new Date();
      return date.toLocaleDateString("fr-FR", { day:"2-digit", month:"short", year:"numeric" });
    }catch(e){ return ""; }
  }

  function stars(rating){
    const n = Math.max(0, Math.min(5, Number(rating || 0)));
    return "★★★★★".slice(0,n) + "☆☆☆☆☆".slice(0,5-n);
  }

  function compressImage(file){
    return new Promise((resolve) => {
      if (!file || !file.type.startsWith("image/")) return resolve(null);
      const reader = new FileReader();
      reader.onload = () => {
        const img = new Image();
        img.onload = () => {
          const max = 900;
          let {width, height} = img;
          if(width > height && width > max){
            height = Math.round(height * max / width);
            width = max;
          }else if(height > max){
            width = Math.round(width * max / height);
            height = max;
          }
          const canvas = document.createElement("canvas");
          canvas.width = width;
          canvas.height = height;
          canvas.getContext("2d").drawImage(img,0,0,width,height);
          resolve(canvas.toDataURL("image/jpeg", 0.72));
        };
        img.onerror = () => resolve(null);
        img.src = reader.result;
      };
      reader.onerror = () => resolve(null);
      reader.readAsDataURL(file);
    });
  }

  async function init(){
    const root = document.getElementById("mtrReviews");
    if(!root) return;

    await loadScript(firebaseScripts[0]);
    await loadScript(firebaseScripts[1]);

    if(!firebase.apps.length) firebase.initializeApp(firebaseConfig);
    const db = firebase.firestore();

    const productId = String(root.dataset.productId || "");
    const productTitle = root.dataset.productTitle || "";
    const productUrl = root.dataset.productUrl || "";

    const modal = document.getElementById("mtrReviewModal");
    const openBtn = document.getElementById("mtrOpenReview");
    const closeEls = document.querySelectorAll("[data-mtr-close]");
    const toggleBtn = document.getElementById("mtrToggleReviews");
    const list = document.getElementById("mtrReviewList");
    let reviewsOpen = false;
    const empty = document.getElementById("mtrEmpty");
    const averageEl = document.getElementById("mtrAverage");
    const averageStarsEl = document.getElementById("mtrAverageStars");
    const countEl = document.getElementById("mtrCount");
    const form = document.getElementById("mtrReviewForm");
    const ratingInput = document.getElementById("mtrRating");
    const starButtons = document.querySelectorAll("#mtrStarPicker button");
    const status = document.getElementById("mtrStatus");
    const submit = document.getElementById("mtrSubmit");

    function openModal(){
      if(!modal) return;
      modal.classList.add("active");
      modal.setAttribute("aria-hidden", "false");
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
    }

    function closeModal(){
      if(!modal) return;
      modal.classList.remove("active");
      modal.setAttribute("aria-hidden", "true");
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
    }

    openBtn && openBtn.addEventListener("click", openModal);
    closeEls.forEach(el => el.addEventListener("click", closeModal));
    document.addEventListener("keydown", e => {
      if(e.key === "Escape" && modal && modal.classList.contains("active")) closeModal();
    });

    toggleBtn && toggleBtn.addEventListener("click", () => {
  if (!list) return;

  reviewsOpen = !reviewsOpen;

  if (reviewsOpen) {
    list.removeAttribute("hidden");
    toggleBtn.textContent = "Masquer les avis";

    if (empty && !list.querySelector(".mtr-review-item")) {
      empty.style.display = "grid";
    }
  } else {
    list.setAttribute("hidden", "");
    toggleBtn.textContent = "Voir les avis";

    if (empty) {
      empty.style.display = "none";
    }
  }
});
    function setRating(value){
      const n = Number(value);
      if(ratingInput) ratingInput.value = n;
      starButtons.forEach(btn => {
        btn.classList.toggle("active", Number(btn.dataset.rating) <= n);
      });
    }

    starButtons.forEach(btn => btn.addEventListener("click", () => setRating(btn.dataset.rating)));

    function render(reviews){
      if(!list || !empty || !averageEl || !averageStarsEl || !countEl) return;

      list.querySelectorAll(".mtr-review-item").forEach(el => el.remove());

      const count = reviews.length;
      const avg = count ? reviews.reduce((sum, r) => sum + Number(r.rating || 0), 0) / count : 0;

      averageEl.textContent = count ? avg.toFixed(1).replace(".", ",") : "—";
      averageStarsEl.textContent = count ? stars(Math.round(avg)) : "★★★★★";
      countEl.textContent = count ? `${count} avis` : "Aucun avis";

      if (count === 0) {
  empty.style.display = list.hasAttribute("hidden") ? "none" : "grid";
} else {
  empty.style.display = "none";
}

      reviews.forEach((review, index) => {
        const item = document.createElement("article");
        const isFiveStar = Number(review.rating || 0) === 5;
        item.className = "mtr-review-item" + (isFiveStar ? " mtr-review-five" : "") + (isFiveStar && index === 0 ? " mtr-review-featured" : "");
        const photos = Array.isArray(review.photos) ? review.photos.slice(0,3) : [];
        item.innerHTML = `
          <div class="mtr-review-item-top">
            <div>
              <div class="mtr-review-author-line">
                <div class="mtr-review-author">${escapeHtml(review.name || "Client MoRetro")}</div>
                <span class="mtr-verified-badge">✓ Achat vérifié</span>
              </div>
              ${isFiveStar && index === 0 ? `<div class="mtr-featured-badge">🏆 Avis le plus utile</div>` : ""}
              <div class="mtr-stars">${stars(review.rating)}</div>
            </div>
            <div class="mtr-review-date">${formatDate(review.createdAt)}</div>
          </div>
          ${review.title ? `<h3 class="mtr-review-title">${escapeHtml(review.title)}</h3>` : ""}
          <p class="mtr-review-body">${escapeHtml(review.body)}</p>
          ${photos.length ? `<div class="mtr-review-photos" data-mtr-gallery='${escapeHtml(JSON.stringify(photos))}'>${photos.map((p, i) => `<button type="button" class="mtr-photo-btn" data-mtr-photo-index="${i}" aria-label="Agrandir la photo ${i + 1}"><img src="${p}" alt="Photo avis client"></button>`).join("")}</div>` : ""}
        `;
        list.appendChild(item);
      });
    }

    if (!reviewsOpen) {
  list.setAttribute("hidden", "");
} else {
  list.removeAttribute("hidden");
}

    db.collection("reviews")
      .where("productId", "==", productId)
      .where("status", "==", "published")
      .onSnapshot(snapshot => {
        const reviews = [];
        snapshot.forEach(doc => reviews.push(doc.data()));

        reviews.sort((a,b) => {
          const da = a.createdAt && a.createdAt.toMillis ? a.createdAt.toMillis() : 0;
          const dbb = b.createdAt && b.createdAt.toMillis ? b.createdAt.toMillis() : 0;
          return dbb - da;
        });

        render(reviews);
      }, error => {
        console.error("MoRetro reviews Firestore error:", error);
        if(status){
          status.hidden = false;
          status.classList.add("error");
          status.textContent = "Impossible de charger les avis. Vérifie les règles Firebase.";
        }
      });


    let mtrPhotoGallery = [];
    let mtrPhotoIndex = 0;
    let mtrTouchStartX = 0;

    function ensurePhotoLightbox(){
      let overlay = document.getElementById("mtrPhotoLightbox");

      if(!overlay){
        overlay = document.createElement("div");
        overlay.id = "mtrPhotoLightbox";
        overlay.className = "mtr-photo-lightbox";
        overlay.setAttribute("aria-hidden", "true");
        overlay.innerHTML = `
          <button type="button" class="mtr-photo-lightbox-close" aria-label="Fermer">×</button>
          <button type="button" class="mtr-photo-lightbox-nav mtr-photo-lightbox-prev" aria-label="Photo précédente">‹</button>
          <img class="mtr-photo-lightbox-img" alt="Photo avis client agrandie">
          <button type="button" class="mtr-photo-lightbox-nav mtr-photo-lightbox-next" aria-label="Photo suivante">›</button>
          <div class="mtr-photo-lightbox-count"></div>
        `;
        document.body.appendChild(overlay);
      }

      return overlay;
    }

    function updatePhotoLightbox(){
      const overlay = ensurePhotoLightbox();
      const img = overlay.querySelector(".mtr-photo-lightbox-img");
      const count = overlay.querySelector(".mtr-photo-lightbox-count");
      const prev = overlay.querySelector(".mtr-photo-lightbox-prev");
      const next = overlay.querySelector(".mtr-photo-lightbox-next");

      if(!img || !mtrPhotoGallery.length) return;

      img.src = mtrPhotoGallery[mtrPhotoIndex];

      if(count){
        count.textContent = mtrPhotoGallery.length > 1 ? `${mtrPhotoIndex + 1} / ${mtrPhotoGallery.length}` : "";
      }

      if(prev) prev.hidden = mtrPhotoGallery.length <= 1;
      if(next) next.hidden = mtrPhotoGallery.length <= 1;
    }

    function openPhotoLightbox(gallery, index){
      mtrPhotoGallery = Array.isArray(gallery) && gallery.length ? gallery : [];
      mtrPhotoIndex = Math.max(0, Math.min(Number(index || 0), mtrPhotoGallery.length - 1));

      if(!mtrPhotoGallery.length) return;

      const overlay = ensurePhotoLightbox();
      updatePhotoLightbox();

      overlay.classList.add("active");
      overlay.setAttribute("aria-hidden", "false");
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
    }

    function closePhotoLightbox(){
      const overlay = document.getElementById("mtrPhotoLightbox");
      if(!overlay) return;

      const img = overlay.querySelector(".mtr-photo-lightbox-img");

      overlay.classList.remove("active");
      overlay.setAttribute("aria-hidden", "true");
      if(img) img.src = "";

      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
    }

    function showPhotoOffset(offset){
      if(!mtrPhotoGallery.length) return;
      mtrPhotoIndex = (mtrPhotoIndex + offset + mtrPhotoGallery.length) % mtrPhotoGallery.length;
      updatePhotoLightbox();
    }

    list && list.addEventListener("click", (event) => {
      const btn = event.target.closest("[data-mtr-photo-index]");
      if(!btn) return;

      const galleryWrap = btn.closest("[data-mtr-gallery]");
      if(!galleryWrap) return;

      let gallery = [];
      try{
        gallery = JSON.parse(galleryWrap.dataset.mtrGallery || "[]");
      }catch(e){
        gallery = [];
      }

      event.preventDefault();
      openPhotoLightbox(gallery, Number(btn.dataset.mtrPhotoIndex || 0));
    });

    document.addEventListener("click", (event) => {
      const overlay = document.getElementById("mtrPhotoLightbox");
      if(!overlay || !overlay.classList.contains("active")) return;

      if(event.target === overlay || event.target.closest(".mtr-photo-lightbox-close")){
        closePhotoLightbox();
        return;
      }

      if(event.target.closest(".mtr-photo-lightbox-prev")){
        showPhotoOffset(-1);
        return;
      }

      if(event.target.closest(".mtr-photo-lightbox-next")){
        showPhotoOffset(1);
      }
    });

    document.addEventListener("keydown", (event) => {
      const overlay = document.getElementById("mtrPhotoLightbox");
      const isOpen = overlay && overlay.classList.contains("active");
      if(!isOpen) return;

      if(event.key === "Escape") closePhotoLightbox();
      if(event.key === "ArrowLeft") showPhotoOffset(-1);
      if(event.key === "ArrowRight") showPhotoOffset(1);
    });

    document.addEventListener("touchstart", (event) => {
      const overlay = document.getElementById("mtrPhotoLightbox");
      if(!overlay || !overlay.classList.contains("active")) return;
      mtrTouchStartX = event.touches && event.touches[0] ? event.touches[0].clientX : 0;
    }, {passive:true});

    document.addEventListener("touchend", (event) => {
      const overlay = document.getElementById("mtrPhotoLightbox");
      if(!overlay || !overlay.classList.contains("active")) return;

      const endX = event.changedTouches && event.changedTouches[0] ? event.changedTouches[0].clientX : 0;
      const diff = endX - mtrTouchStartX;

      if(Math.abs(diff) > 45){
        showPhotoOffset(diff > 0 ? -1 : 1);
      }
    }, {passive:true});

    form && form.addEventListener("submit", async (event) => {
      event.preventDefault();
      if(status){
        status.hidden = false;
        status.classList.remove("error");
        status.textContent = "Envoi de l’avis en cours...";
      }
      if(submit) submit.disabled = true;

      try{
        const photosInput = document.getElementById("mtrPhotos");
        const files = [...((photosInput && photosInput.files) || [])].slice(0,3);
        const photosRaw = await Promise.all(files.map(compressImage));
        const photos = photosRaw.filter(Boolean);

        const review = {
          productId,
          productTitle,
          productUrl,
          rating: Number((document.getElementById("mtrRating") || {}).value || 5),
          name: (document.getElementById("mtrName") || {}).value.trim(),
          email: (document.getElementById("mtrEmail") || {}).value.trim(),
          title: (document.getElementById("mtrTitle") || {}).value.trim(),
          body: (document.getElementById("mtrBody") || {}).value.trim(),
          photos,
          status: "pending",
          createdAt: firebase.firestore.FieldValue.serverTimestamp()
        };

        if(!review.name || !review.email || !review.body){
          throw new Error("Champs obligatoires manquants.");
        }

        await db.collection("reviews").add(review);

        if(status){
          status.textContent = "Merci ❤️ Votre avis a bien été envoyé et sera publié après validation.";
        }
        form.reset();
        setRating(5);
        setTimeout(closeModal, 1400);
      }catch(error){
        console.error(error);
        if(status){
          status.classList.add("error");
          status.textContent = "Erreur pendant l’envoi. Vérifie Firebase ou réessaie.";
        }
      }finally{
        if(submit) submit.disabled = false;
      }
    });
  }

  document.addEventListener("DOMContentLoaded", init);
})();
